export const AbstractLoading = () => {
  return (
    <div className="animate-pulse">
      <div className="flex flex-col gap-2 mb-4 ">
        <div className="bg-border-base h-3 w-[63%]  rounded-full" />
        <div className="bg-border-base h-3 w-full rounded-full" />
        <div className="bg-border-base h-3 w-[90%] rounded-full" />
      </div>
    </div>
  );
};
